export const blockIconsSocialDiversity3New = (
	<span className='material-symbols-outlined'>diversity_3</span>
);
